<template>
  <ModuleContainer
    :id="'cmp-booking-container'"
    :inactive_routes="detailsRoutes"
  >
    <!-- <v-container fluid :class="bookingContainerClass">
    <v-slide-y-transition mode="out-in">
        <router-view/>
    </v-slide-y-transition>-->

    <template #modals>
      <template v-if="freeDatesModalContainer">
        <v-dialog v-model="freeDatesModal" persistent width="1200">
          <FreeDates @cancelled="onFreeDatesModalCancelled" />
        </v-dialog>
      </template>

      <template v-if="taskDetailsModalContainer">
        <v-dialog v-model="taskDetailsModal" persistent width="900">
          <TaskDetails @cancelled="onTaskDetailsModalCancelled" @changed="onTaskListItemChanged" />
        </v-dialog>
      </template>

      <template v-if="createInfoModalContainer">
        <v-dialog v-model="createInfoModal" persistent width="762">
          <CreateInfo
            @added="onInfoAdded"
            @cancelled="onCreateInfoModalCancelled"
          />
        </v-dialog>
      </template>

      <template v-if="addUserModalContainer">
        <v-dialog :value="addUserModal" persistent width="762">
          <UserList @added="onAddUser" @cancelled="onAddUserCancelled" />
        </v-dialog>
      </template>

      <!--
      <ModalContainer :modalKey="'addUser'" :width="'small'">
        <UserList @added="onAddUser" @cancelled="onAddUserCancelled" />
      </ModalContainer>
      -->

      <template v-if="addCountryModalContainer">
        <v-dialog v-model="addCountryModal" persistent width="562">
          <AddCountry
            @added="onAddCountry"
            @cancelled="onAddCountryCancelled"
          />
        </v-dialog>
      </template>

      <template v-if="addFieldModalContainer">
        <v-dialog v-model="addFieldModal" persistent width="562">
          <AddField @added="onFieldAdded" @cancelled="onAddFieldCancelled" />
        </v-dialog>
      </template>
      <!-- 
      <ModalContainer :modalKey="'addField'" :width="'small'">
        <AddField @added="onFieldAdded" @cancelled="onAddFieldCancelled" />
      </ModalContainer>
      -->

      <template v-if="addArtistModalContainer">
        <v-dialog v-model="addArtistModal" persistent width="390">
          <AddArtist @added="onArtistAdded" @cancelled="onAddArtistCancelled" />
        </v-dialog>
      </template>

      <!-- <template v-if="chooseMailTemplateModalContainer">
        <v-dialog v-model="chooseMailTemplateModal" persistent width="400">
          <ChooseMailTemplate
            @cancelled="onHideComponentModal"
          ></ChooseMailTemplate>
        </v-dialog>
      </template> -->

      <template v-if="addVenueModalContainer">
        <v-dialog v-model="addVenueModal" persistent width="562">
          <AddVenue
            @added="onVenueAdded"
            @selected="onVenueSelected"
            @cancelled="onModalCancel"
          />
        </v-dialog>
      </template>
      <!-- 
      <ModalContainer :modalKey="'addVenue'" :width="'small'">
        <AddVenue @added="onVenueAdded" @selected="onVenueSelected" @cancelled="onModalCancel" />
      </ModalContainer>
      -->

      <template v-if="requestModalContainer">
        <v-dialog v-model="requestModal" persistent width="800">
          <RequestForm @done="onRequestDone" @cancelled="onRequestCancelled" />
        </v-dialog>
      </template>

      <template v-if="addCommentModalContainer">
        <v-dialog v-model="addCommentModal" persistent width="800">
          <AddComment
            @cancelled="onaddCommentCancelled"
            @done="onAddCommentDone"
          />
        </v-dialog>
      </template>
      <!-- 
      <ModalContainer :modalKey="'addComment'" :width="'small'">
        <AddComment @cancelled="onaddCommentCancelled" @done="onAddCommentDone" />
      </ModalContainer>
      -->

      <template v-if="addGenreModalContainer">
        <v-dialog v-model="addGenreModal" persistent width="1200">
          <AddGenre @done="onGenreAdd" @cancelled="onaddGenreCancelled" />
        </v-dialog>
      </template>
      <!-- 
      <ModalContainer :modalKey="'addGenre'" :width="572">
        <AddGenre @done="onGenreAdd" @cancelled="onaddGenreCancelled" />
      </ModalContainer>
      -->

      <template v-if="bookingWizardModalContainer">
        <v-dialog v-model="bookingWizardModal" persistent width="762">
          <BookingWizard
            :addBookingData="addBookingData"
            @done="onBookingWizardDone"
            @cancelled="onBookingWizardCancelled"
          />
        </v-dialog>
      </template>

      <template v-if="chooseMailTemplateModalContainer">
        <v-dialog v-model="chooseMailTemplateModal" persistent width="390">
          <ChooseMailTemplate
            @cancelled="onHideComponentModal"
          ></ChooseMailTemplate>
        </v-dialog>
      </template>
      <template v-if="availableArtistsModalContainer">
        <v-dialog v-model="availableArtistsModal" persistent width="562">
          <AvailableArtists
            @cancelled="onHideComponentModal"
          ></AvailableArtists>
        </v-dialog>
      </template>
    </template>

    <!-- <template v-if="chooseMailTemplateModalContainer">
      <v-dialog v-model="chooseMailTemplateModal" persistent width="400">
        <ChooseMailTemplate
          @cancelled="onHideComponentModal"
        ></ChooseMailTemplate>
      </v-dialog>
    </template> -->

    <!-- <ModalContainer
      :modalKey="'chooseMailTemplate'"
      :width="'small'"
      @cancelled="onHideComponentModal"
    >
      <ChooseMailTemplate
        @cancelled="onHideComponentModal"
      ></ChooseMailTemplate>
    </ModalContainer> -->

    <!-- </v-container> -->
  </ModuleContainer>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "./store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "./store/types";
import * as AppActionTypes from "../../store/app/types";

import { waitForAnimation } from "../../utility";

import FreeDates from "./components/free-dates";
import TaskDetails from "./components/task-details";
import AvailableArtists from "./components/available-artists";
import CreateInfo from "./components/artist/artist-sidewindow/create-info";
import AddCountry from "./components/artist/artist-sidewindow/add-country";
import AddField from "./components/artist/artist-sidewindow/add-field";
import AddArtist from "./components/artist/artist-sidewindow/add-artist";
import AddVenue from "./components/venue/add-venue";
import RequestForm from "./components/requests/booking-request-form";
import AddComment from "../../dt-plugins/comments/add-comment";
import AddGenre from "../../dt-plugins/genres/add-genre";
import BookingWizard from "./components/add-booking";
import ChooseMailTemplate from "./components/choose-mail-template";

import UserList from "../../dt-plugins/user-list/user-list";
import * as I18nActionTypes from "../../store/app/i18n/types";

import {
  closeModalRoute,
  createModalMixin,
} from "../../dt-plugins/modal/modal.mixin";
import { ArtistService } from "./services/artists";
import {
  childOfOrEqual,
  childOfOrEqualSome,
  bookingRequestsWizardRouterName,
  bookingRequestsRouterName,
} from "../../router/functions";
import { bookingVenueListLDTRoutes } from "./router/routes";
import {
  bookingCalCalendarDateRoute,
  bookingListCalendarDateRoute,
  artistDetailsRoute,
  bookingListCalendarDateTabRoute,
  bookingVenueRoutes,
  bookingTemplateDetailsRoute,
} from "./router/router";
import {
  createAddBookingModel,
  findAddBookingTabIndex,
} from "./models/add-booking.model";
import { createBookingOverview } from "./models/booking-overview.model";
import { bookingsActions } from "./store/bookings/actions";
import { mapActionObject } from "../../store/global";
import ModalContainer from "@dtplugins/modal/modal-container";

import ModuleContainer from "@dtplugins/module/dtmodule";

export default {
  components: {
    ModuleContainer,
    ModalContainer,

    FreeDates,
    TaskDetails,
    AvailableArtists,
    CreateInfo,
    UserList,
    AddCountry,
    AddField,

    AddArtist,
    AddVenue,
    RequestForm,
    AddComment,
    AddGenre,
    BookingWizard,
    ChooseMailTemplate,
  },
  data: function () {
    return {
      freeDatesModalContainer: null,
      freeDatesModal: null,

      requestModalContainer: null,
      requestModal: null,

      bookingWizardModalContainer: null,
      bookingWizardModal: null,

      chooseMailTemplateModalContainer: null,
      chooseMailTemplateModal: null,

      addBookingConfig: null,

      // MARK: Data
    };
  },
  mounted: function () {
    this[ActionTypes.FETCH_BOOKING_MODULE_INFO]();
    this.$store.dispatch(AppActionTypes.FETCH_REQUEST_COUNT);

    this.$store.dispatch(I18nActionTypes.INSERT_SYSTEM_LANGUAGE_SECTION, [
      "booking",
    ]);
  },
  mixins: [
    createModalMixin("createInfo", ["edit_info"]),
    createModalMixin("addUser"),
    createModalMixin("addCountry"),
    createModalMixin("addField"),
    createModalMixin("chooseMailTemplate"),
    createModalMixin("addArtist"),
    createModalMixin("addVenue"),
    createModalMixin("addComment"),
    createModalMixin("addGenre"),
    createModalMixin("availableArtists"),
    createModalMixin("taskDetails"),
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        if (to && to.query.modal === "free_dates") {
          this.freeDatesModalContainer = true;
          setTimeout(() => {
            this.freeDatesModal = true;
          }, 1);
        } else if (
          from &&
          from.query.modal === "free_dates" &&
          to.query.modal !== "free_dates"
        ) {
          this.freeDatesModal = false;
          waitForAnimation(() => {
            this.freeDatesModalContainer = false;
          });
        }

        if (to && to.query.modal === "free_dates") {
          this.freeDatesModalContainer = true;
          setTimeout(() => {
            this.freeDatesModal = true;
          }, 1);
        } else if (
          from &&
          from.query.modal === "free_dates" &&
          to.query.modal !== "free_dates"
        ) {
          this.freeDatesModal = false;
          waitForAnimation(() => {
            this.freeDatesModalContainer = false;
          });
        }

        this.externalId = to.query && to.query.external_id;
        this.externalTable = to.query && to.query.external_table;

        // Request Modal
        if (to && to.name === bookingRequestsWizardRouterName) {
          this.requestModalContainer = true;
          waitForAnimation(() => {
            this.requestModal = true;
          });
        } else if (
          from &&
          from.name === bookingRequestsWizardRouterName &&
          to.name !== bookingRequestsWizardRouterName
        ) {
          this.requestModal = false;
          waitForAnimation(() => {
            this.requestModalContainer = false;
          });
        }

        // console.log('R CHANG', to, from);

        // Booking Wizard Modal
        if (to && to.query.modal === "booking-wizard") {
          this.bookingWizardModalContainer = true;
          const tab = to.query.tab;
          this.addBookingConfig = {
            activeTab: findAddBookingTabIndex(tab),
          };
          waitForAnimation(() => {
            this.bookingWizardModal = true;
          });
        } else if (
          from &&
          from.query.modal === "booking-wizard" &&
          to.query.modal !== "booking-wizard"
        ) {
          this.bookingWizardModal = false;
          waitForAnimation(() => {
            this.bookingWizardModalContainer = false;
          });
        }

        // // Choose Mail Template Modal
        // if (to && to.query.modal === "choose_mail_template") {
        //   this.chooseMailTemplateModalContainer = true;
        //   waitForAnimation(() => {
        //     this.chooseMailTemplateModal = true;
        //   });
        // } else if (
        //   from &&
        //   from.query.modal === "choose_mail_template" &&
        //   to.query.modal !== "choose_mail_template"
        // ) {
        //   this.chooseMailTemplateModal = false;
        //   waitForAnimation(() => {
        //     this.chooseMailTemplateModalContainer = false;
        //   });
        // }
      },
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      // bookingDetailsFlag: 'bookingDetailsFlag',
      // bookingModuleActive: 'bookingModuleActive'
      bookingOverview: "booking",
      bookingDetails: "bookingDetails",
    }),
    calendar_date_id: function () {
      return this.$route.params.calendar_date_id || "";
    },
    booking: function () {
      return this.bookingDetails[this.calendar_date_id];
    },
    detailsRoutes: function () {
      return [
        bookingCalCalendarDateRoute,
        bookingListCalendarDateRoute,
        artistDetailsRoute,
        bookingVenueRoutes.names.details,
        bookingTemplateDetailsRoute,
      ];
      return [
        bookingCalCalendarDateRoute,
        bookingListCalendarDateRoute,
        artistDetailsRoute,
        bookingVenueRoutes.names.details,
      ];
    },
    bookingModuleActive: function () {
      return !childOfOrEqualSome([
        bookingCalCalendarDateRoute,
        bookingListCalendarDateRoute,
        artistDetailsRoute,
        bookingVenueRoutes.names.details,
      ])(this.$route.name);
    },
    bookingContainerClass: function () {
      return {
        "cmp-booking-container": true,
        "dt-module": true,
        inactive: !this.bookingModuleActive,
      };
    },
    addBookingData: function () {
      console.log("Log: this.bookingOverview", this.bookingOverview);

      const bookingOv = this.booking || {};
      const booking = bookingOv?.cdate || {};
      console.log("Log: bookingOv", bookingOv, this.booking);
      const addBookingData = createAddBookingModel({
        startDate: booking.start_date,
        endDate: booking.end_date,
        city: booking.city,
        country: booking.country,
        countries: bookingOv.countries,
        selectedCountry: {
          text: booking.country,
          value: booking.country,
        },
        eventName: booking.date_name,
        dealMemo: booking.first_offer_notes,

        selectedArtists: new Set(bookingOv?.artists?.map((a) => a.artist_id)),
        selectedVenue: bookingOv.location,
        selectedPromoter: bookingOv.promoter,
        selectedContact: bookingOv.promoter2,
        calendarDateId: booking.calendar_date_id,
        user: { user_id: booking.user_id },

        bookingWizard: true,
        ...this.addBookingConfig,
      });

      console.log(addBookingData);
      return addBookingData;
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.FETCH_BOOKING_MODULE_INFO]:
        ActionTypes.FETCH_BOOKING_MODULE_INFO,
      [ActionTypes.UPDATE_SELECTED_ARTIST_DATA]:
        ActionTypes.UPDATE_SELECTED_ARTIST_DATA,
      [ActionTypes.ARTIST_RELATED_USER.INSERT.MULTIPLE]:
        ActionTypes.ARTIST_RELATED_USER.INSERT.MULTIPLE,
      [ActionTypes.ADD_ARTIST_CUSTOM_DATA]: ActionTypes.ADD_ARTIST_CUSTOM_DATA,
      [ActionTypes.CREATE_ARTIST]: ActionTypes.CREATE_ARTIST,
      [ActionTypes.FETCH_BOOKING_OVERVIEW]: ActionTypes.FETCH_BOOKING_OVERVIEW,
      [ActionTypes.INSERT_VENUE]: ActionTypes.INSERT_VENUE,
    }),
    ...mapActionObject(storeNS, bookingsActions),

    onTaskDetailsModalCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onFreeDatesModalCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onInfoAdded: function (artistId) {
      this.onCreateInfoModalCancelled();

      ArtistService.findRelatedInfos({
        artistId,
      }).then((res) => {
        console.log(res);
        this[ActionTypes.UPDATE_SELECTED_ARTIST_DATA]({
          related_infos: res.data.related_infos,
        });
      });
    },
    onCreateInfoModalCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddUser: function (users) {
      const artist_id = this.$route.params.artist_id;
      this[ActionTypes.ARTIST_RELATED_USER.INSERT.MULTIPLE]({ users, artist_id });
      this.onAddUserCancelled();
    },
    onAddUserCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          artist_id: undefined,
          section: undefined,
        },
      });
    },

    onAddCountry: function (res) {
      this.onAddCountryCancelled();
      this[ActionTypes.UPDATE_SELECTED_ARTIST_DATA]({
        related_countries: res.data.related_countries,
        artist_id: res.data.artist_id
      });
    },

    onAddCountryCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          artist_id: undefined,
        },
      });
    },
    onAddFieldCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          artist_id: undefined,
          external_table: undefined,
        },
      });
    },
    onFieldAdded: function (payload) {
      this[ActionTypes.ADD_ARTIST_CUSTOM_DATA](payload);
      this.onAddFieldCancelled();
    },
    onArtistAdded: function (res) {
      console.log(res);
      this[ActionTypes.CREATE_ARTIST](res);
      this.onAddArtistCancelled();
    },
    onVenueAdded: function (res) {
      this[ActionTypes.INSERT_VENUE](res).then((newLocation) => {
        console.log("Venue Added", newLocation.booking_location_id);
        this.$router.push({
          name: bookingVenueListLDTRoutes.names.tab,
          params: {
            venue_id: newLocation.booking_location_id,
            tab: "overview",
          },
        });
      });
    },
    onVenueSelected: function (location) {
      this.$router.push({
        name: bookingVenueRoutes.names.tab,
        params: {
          venue_id: location.booking_location_id,
          tab: "overview",
        },
      });
    },
    onAddArtistCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onModalCancel: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onRequestDone: function (value) {
      if (value) {
        this.$router.push({
          name: bookingListCalendarDateTabRoute,
          params: {
            calendar_date_id: this.$route.params.calendar_date_id,
            tab: "overview",
          },
        });
      }
    },
    onRequestCancelled: function () {
      this.$router.push({
        name: bookingRequestsRouterName,
      });
    },
    onaddCommentCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          status: undefined,
        },
      });
    },
    onAddCommentDone: function (commentRes) {
      console.log(commentRes);
      this.onaddCommentCancelled();
      this.$store.dispatch(commentRes.action, commentRes.data);
    },
    onaddGenreCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          section: undefined,
          id: undefined,
          external_table: undefined,
        },
      });
    },
    onGenreAdd: function ({ action, booking_location_id }) {
      console.log(action, booking_location_id);
      this.onaddGenreCancelled();
      this.$store.dispatch(action, {
        booking_location_id,
      });
    },
    onBookingWizardDone: function (calendarDateId) {
      // console.log("Log: calendarDateId", calendarDateId)
      this[ActionTypes.BookingDetails.FETCH.SINGLE]({
        calendar_date_id: calendarDateId,
        reload: true,
      });
      this.onBookingWizardCancelled();
    },
    onBookingWizardCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          tab: undefined,
        },
      });
    },

    onHideComponentModal: function () {
      closeModalRoute(this, {
        type: undefined,
        document_id: undefined,
        invoice_id: undefined,
        file_relation_id: undefined,
        calendar_date_id: undefined,
        artist_id: undefined,
        date: undefined,
      });
    },
    onTaskListItemChanged: function (payload) {
      this[ActionTypes.BDTaskList.UPDATE.SINGLE](payload);
      // console.log('mdsir: load task', payload);
    },

    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-booking-container {
  overflow: hidden;
}
</style>
